// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"c2368ea4","689":"c2368ea4"}[chunkId] + ".chunk.css";
};